var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16536 1.875C7.51054 1.875 7.79036 2.15482 7.79036 2.5V3.54167H13.207V2.5C13.207 2.15482 13.4869 1.875 13.832 1.875C14.1772 1.875 14.457 2.15482 14.457 2.5V3.54167H15.4987C16.7644 3.54167 17.7904 4.56768 17.7904 5.83333V6.875H3.20703V5.83333C3.20703 4.56768 4.23305 3.54167 5.4987 3.54167H6.54036V2.5C6.54036 2.15482 6.82019 1.875 7.16536 1.875Z",
    fill: "#D909C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20703 8.125V15C3.20703 16.2657 4.23305 17.2917 5.4987 17.2917H15.4987C16.7644 17.2917 17.7904 16.2657 17.7904 15V8.125H3.20703Z",
    fill: "#D909C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculate);
export default __webpack_public_path__ + "static/media/icon_calculate.79dacd80113233570441121a1cef90e4.svg";
export { ForwardRef as ReactComponent };